// root
export const RESET_TREE = 'RESET_TREE'
export const SET_ROOT = 'SET_ROOT'
export const SET_UPDATE = 'SET_UPDATE'

// module config
export const REMOVE_CONFIG = 'REMOVE_CONFIG'
export const SWITCH_CONFIG = 'SWITCH_CONFIG'

// module actions
export const ADD_MODULE = 'ADD_MODULE'
export const SET_ACTIVE_MODULE = 'SET_ACTIVE_MODULE'
export const DELETE_MODULE = 'DELETE_MODULE'

// update config
export const SET_BASE_INFO = 'SET_BASE_INFO'
export const COMPONENT_SORT_CHANGE = 'COMPONENT_SORT_CHANGE'

export const SET_BANNER_INFO = 'SET_BANNER_INFO'
export const SET_TABLIST_INFO = 'SET_TABLIST_INFO'
export const SET_TAB_ACTIVE_INDEX = 'SET_TAB_ACTIVE_INDEX'
export const SET_TAB_BASE = 'SET_TAB_BASE'
export const DELETE_TABITEM = 'DELETE_TABITEM'
export const SET_BRANSLIST_INFO = 'SET_BRANSLIST_INFO'
export const ADD_BRANDLIST = 'ADD_BRANDLIST'
export const SET_INFO = 'SET_INFO'
export const SET_PRODUCTSLIST = 'SET_PRODUCTSLIST'
export const SET_VIDEO_SRC = 'SET_VIDEO_SRC'
export const SET_TEXT_BOX = 'SET_TEXT_BOX'
export const DELETE_TAB_CHILD_NODE = 'DELETE_TAB_CHILD_NODE'
export const RESET_BASE_PANES = 'RESET_BASE_PANES'
// image box
export const SET_IMAGE_BOX = 'SET_IMAGE_BOX'
export const SET_IMAGE_RES = 'SET_IMAGE_RES'
export const SET_IMAGE_BASE = 'SET_IMAGE_BASE'
// mixedBox
export const SET_MIXED_BLOCK = 'SET_MIXED_BLOCK'
//
export const SET_TAB_BAR = 'SET_TAB_BAR'
// common config
export const SET_COMMON_CONFIG = 'SET_COMMON_CONFIG'
// confernece

export const SET_CONFERENCE = 'SET_CONFERENCE'
export const ADD_CONFERENCE_TAB = 'ADD_CONFERENCE_TAB'

export const SET_TIME = 'SET_TIME'

export const LOGIN = 'LOGIN'
export const LOGIN_OUT = 'LOGIN_OUT'

// components
export const ADD_COMPONENT = 'ADD_COMPONENT'
//

export const GET_TEMPLATELIST = 'GET_TEMPLATELIST'
export const SET_TEMPLATELIST = 'SET_TEMPLATELIST'
export const SAVE_ARTICLE = 'SAVE_ARTICLE'
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE'

// material

export const SET_INSTANCE = 'SET_INSTANCE'

export const SET_BASE_DATA = 'SET_BASE_DATA'
